module.exports = __webpack_public_path__ + "static_portal/img/steve_good_video_example.80dec8cd.jpg";